import { ITemplateStylingSettings } from '@/components/settings-page/platformSettings/templatesSettings/types';
import { IFieldEditor } from '@/shared/types/fieldEditor';
import { getEnumKeyByValue } from '@/shared/utils/enums';
import { updateMarkdownImageUrls } from '@/shared/utils/fieldEditor';
import { Text, View } from '@react-pdf/renderer';
import { AIFieldType } from '@trace-8/trace8-schema';
import { DefaultTheme } from 'styled-components/dist/types';
import { formatAiFieldValueForTemplate, formatFieldValueForTemplate } from '../../../utils';
import { templateStyles } from '../../style';
import { convertMarkdownToReactPDF } from '../../utils';
import { PDFMagicWandIcon } from '../PDFMagicWandIcon';

interface TwoColumnSectionProps {
  fields: IFieldEditor[];
  templateStylingData: ITemplateStylingSettings;
  includeAiSuggested: boolean;
  theme: DefaultTheme;
}

export const TwoColumnSection = ({ fields, templateStylingData, includeAiSuggested, theme }: TwoColumnSectionProps) => {
  return (
    <View break={true} style={{ marginBottom: '30px' }}>
      <View
        style={{
          ...templateStyles.swotWrapper,
          color: theme.font.base
        }}
      >
        {fields.map((field, index) => (
          <View
            key={field.id}
            style={{
              ...templateStyles.swotItem,
              backgroundColor: (index + 1) % 3 === 1 ? '#F4F5F6' : '#EBF0F4'
            }}
            break={Boolean(
              ((index + 1) % 2 === 1 && field.value && field.value.length > 1300) || (field.AI?.answers.length && field.AI?.answers[0].length > 1300)
            )}
          >
            <Text
              style={{
                ...templateStyles.swotHeader,
                color: theme.font.base
              }}
            >
              {field.value === null && field.commentary === null && field.AI?.answers.length && includeAiSuggested ? `* ${field.name}` : field.name}:
            </Text>
            {field.value === null && field.commentary === null && field.AI?.answers.length && includeAiSuggested ? (
              <>
                {field.AI?.answers.length && includeAiSuggested ? (
                  <>
                    {field.documentFieldType === getEnumKeyByValue(AIFieldType, AIFieldType.LONG_FORM_CONTENT) ? (
                      <View>
                        {convertMarkdownToReactPDF(
                          updateMarkdownImageUrls(field.AI.answers[0] || '', field.attachments),
                          templateStylingData,
                          170,
                          theme
                        )}
                      </View>
                    ) : (
                      <Text>{formatAiFieldValueForTemplate(field.documentFieldType, field.AI.answers[0])}</Text>
                    )}
                  </>
                ) : (
                  <Text> Not specified</Text>
                )}
              </>
            ) : (
              <>
                {field.value || field.commentary ? (
                  <>
                    {field.documentFieldType === getEnumKeyByValue(AIFieldType, AIFieldType.LONG_FORM_CONTENT) ? (
                      <View>
                        {convertMarkdownToReactPDF(updateMarkdownImageUrls(field.value || '', field.attachments), templateStylingData, 170, theme)}
                      </View>
                    ) : (
                      <Text>{formatFieldValueForTemplate(field.documentFieldType, field.value, field.commentary)}</Text>
                    )}
                  </>
                ) : (
                  <Text> Not specified</Text>
                )}
              </>
            )}
          </View>
        ))}
      </View>
      {fields.filter((field) => (!field.value || field.value === field.AI?.answers[0]) && field.AI?.answers.length).length && includeAiSuggested ? (
        <View style={{ ...templateStyles.aiIconWrap, color: theme.font.weak }}>
          <View style={{ borderRight: `1px solid ${theme.border.base}`, paddingRight: '3px' }}>
            <PDFMagicWandIcon fill={theme.font.weak} />
          </View>
          <Text style={{ margin: '2px 0 0 5px' }}>{fields.length > 1 ? '* These fields are AI Suggested' : 'This field is AI Suggested'}</Text>
        </View>
      ) : null}
    </View>
  );
};
